import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../../assets/images/logo.png'
import { FaWhatsapp } from "react-icons/fa";
import { useLanguage } from '../../store/languageContext';
import { motion } from 'framer-motion'
import translate from '../../utils/translation';
const Navbar = () => {
    const [open, setOpen] = React.useState(false);
    const { language, toggleLanguage, navColor } = useLanguage();
    return (
        <motion.nav
            initial={{ y: -50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            viewport={{ once: true }}
            className="fixed top-0 z-[100] w-full p-3 sm:p-4" dir='ltr'>
            <div className="container mx-auto flex justify-between items-center gap-2">
                <div className='min-w-0 flex-shrink-0'>
                    <div className={`w-fit border flex gap-1 items-center px-3 py-2 sm:px-4 sm:py-3 rounded-full filter-blur-8 duration-500 cursor-pointer text-sm sm:text-base ${navColor === 'black' ? 'text-black bg-white hover:text-white hover:bg-[#589EEE]' : 'text-white border-[#cccccc41] hover:bg-white hover:text-black'}`} onClick={() => toggleLanguage()}>
                        <span className={`duration-500 ${language === 'en' ? 'opacity-100' : 'opacity-50'} `}>
                            EN
                        </span>
                        <span className='opacity-50'>
                            /
                        </span>
                        <span className={`duration-500 ${language === 'ar' ? 'opacity-100' : 'opacity-50'} `}>
                            AR
                        </span>
                    </div>
                </div>
                <Link to="/" className="text-2xl font-bold chewy-regular flex items-center flex-shrink-0">
                    <img src={logo} alt="logo" className={`size-[48px] sm:size-[56px] md:size-[64px] min-w-[48px] sm:min-w-[56px] md:min-w-[64px] filter duration-500 brightness-0 ${navColor === 'black' ? '' : 'invert'}`} />
                </Link>
                <ul className={`absolute md:static top-full left-0 right-0 md:right-auto bg-black/95 md:bg-transparent backdrop-blur-md md:backdrop-blur-none flex-col md:flex-row items-center gap-3 md:gap-2 p-4 md:p-0 ${open ? 'flex' : 'hidden'} md:flex md:min-w-0`}>
                    <li className={`border px-4 py-2.5 sm:py-3 rounded-full filter-blur-8 duration-500 cursor-pointer text-sm sm:text-base w-full md:w-auto text-center ${navColor === 'black' ? 'text-black bg-white hover:text-white hover:bg-[#589EEE]' : 'text-white border-[#cccccc41] hover:text-black hover:bg-white'}`}><a className='flex gap-2 items-center justify-center' href="https://wa.me/+201117169426" target="_blank" rel="noopener noreferrer"><FaWhatsapp />{translate[language]['contactUs']}</a></li>
                    <li className={`border px-4 py-2.5 sm:py-3 rounded-full filter-blur-8 duration-500 cursor-pointer text-sm sm:text-base w-full md:w-auto text-center ${navColor === 'black' ? 'text-black bg-white hover:text-white hover:bg-[#589EEE] ' : 'text-white border-[#cccccc41] hover:text-black hover:bg-white'}`}><Link to="/products" onClick={() => setOpen(false)}>{translate[language]['products']}</Link></li>
                </ul>
                <button onClick={() => setOpen(!open)} className="md:hidden flex-shrink-0 p-1">
                    {open ? <X className="size-6" /> : <Menu className="size-6" />}
                </button>
            </div>
        </motion.nav>
    );
};

export { Navbar };